<template>
	<page>
		<module enable-flex>
			<m-search @search="updateList">
				<c-form>
					<c-form-item type="input" label="项目编号" name="code"></c-form-item>
					<c-form-item type="input" label="项目名称" name="name"></c-form-item>
					<c-form-item type="input" label="施工单位" name="yzdw_name"></c-form-item>
					<c-form-item type="datetime" label="申请时间" start-name="start_date" end-name="end_date"></c-form-item>
				</c-form>
			</m-search>
			
			<c-table ref="table">
				<c-table-column
					label="状态"
					width="130"
				>
					<template v-slot="{data}">
						<span v-if="proceedState[data.state]" :style="{'color': proceedState[data.state].color}">{{proceedState[data.state].name}}</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="项目编号"
					name="project_code"
					width="100"
				></c-table-column>
				
				<c-table-column
					label="项目名称"
					name="project_name"
					width="200"
				></c-table-column>
				
				<c-table-column
					label="已购买保单"
					width="100"
				>
					<template v-slot="{data}">
						<span v-if="data.bx_count == 0" style="color: #E63633;">未购买</span>
						<span v-else>{{data.bx_count}}份</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="施工单位"
					name="zbqy_name"
					width="250"
				></c-table-column>
				
				<c-table-column
					label="监理单位"
					name="jldw_name"
					width="250"
				></c-table-column>
				
				<c-table-column
					label="业主单位"
					name="yzdw_name"
					width="250"
				></c-table-column>
				
				<c-table-column
					label="申请时间"
					name="create_date"
					width="160"
				></c-table-column>
				
				<c-table-column
					type="button"
					label="操作"
					width="100"
					limit="2"
				>
					<template v-slot="{data}">
						<c-table-button v-if="data.state == 2" @click="navigateTo('/proceed_detail', {id: data.id})">审批</c-table-button>
						<c-table-button v-else @click="navigateTo('/proceed_detail', {id: data.id})">详情</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
	</page>
</template>

<script>
	import {mapGetters} from 'vuex'
	
	export default {
		props: {
			scene: String
		},
		
		computed: {
			...mapGetters(['proceedState'])
		},
		
		mounted() {
			this.updateList();
		},
		
		methods: {
			updateList(data = {}) {
				if (this.scene == 'approve') {
					data.state = 2;
				}
				this.$refs.table.load({
					url: '/project/kgl/list',
					data
				});
			}
		}
	};
</script>

<style lang="stylus" scoped>
</style>